import { render, staticRenderFns } from "./zhihu.vue?vue&type=template&id=a1c69f5e&scoped=true&"
import script from "./zhihu.vue?vue&type=script&lang=js&"
export * from "./zhihu.vue?vue&type=script&lang=js&"
import style0 from "./zhihu.vue?vue&type=style&index=0&id=a1c69f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1c69f5e",
  null
  
)

export default component.exports